import { createUseStyles } from "react-jss";
import { resolveQuestionErrorToLabelGap } from "../../../theme/errorThemeTokens";
import * as Mixins from "../../../theme/Mixins";
import {
    resolveSecurityQuestionAnswerMarginBottom,
    resolveSecurityQuestionContainerPadding,
    resolveSecurityQuestionFieldMarginBottom,
    resolveSecurityQuestionForeground,
    resolveSecurityQuestionTextFontSize,
    resolveSecurityQuestionTextPadding,
    resolveSecurityQuestionTitleFontSize,
    resolveSecurityQuestionTitlePaddingY,
    useModernSecurityQuestionStyles,
} from "../../../theme/securityQuestionThemeTokens";
import { Theme } from "../../../types/Theme";

export default createUseStyles({
    secQuestionTitle: {
        composes: "question__title",
        padding: ({ theme }: { theme: Theme }) => resolveSecurityQuestionTitlePaddingY(theme),
        fontSize: ({ theme }: { theme: Theme }) => resolveSecurityQuestionTitleFontSize(theme),
        fontFamily: ({ theme }: { theme: Theme }) =>
            useModernSecurityQuestionStyles(theme)
                ? `"${theme.TitleFont}", sans-serif`
                : undefined,
        fontWeight: ({ theme }: { theme: Theme }) =>
            useModernSecurityQuestionStyles(theme)
                ? Mixins.getFontWeight(theme.TitleFontVariant, 400)
                : undefined,
        textAlign: ({ theme }: { theme: Theme }) =>
            useModernSecurityQuestionStyles(theme)
                ? Mixins.getTextAlign(theme.TitleTextAlign)
                : undefined,
        color: ({ theme }: { theme: Theme }) => resolveSecurityQuestionForeground(theme),
    },
    secQuestionText: {
        composes: "question__text",
        padding: ({ theme }: { theme: Theme }) => resolveSecurityQuestionTextPadding(theme),
        fontSize: ({ theme }: { theme: Theme }) => resolveSecurityQuestionTextFontSize(theme),
        textAlign: ({ theme }: { theme: Theme }) =>
            useModernSecurityQuestionStyles(theme)
                ? Mixins.getTextAlign(theme.TextTextAlign)
                : undefined,
        color: ({ theme }: { theme: Theme }) => resolveSecurityQuestionForeground(theme),
        wordWrap: ({ theme }: { theme: Theme }) =>
            useModernSecurityQuestionStyles(theme) ? "break-word" : undefined,
    },
    textAnswer: {
        composes: "text-answer",
    },
    securityQuestionContainer: {
        padding: ({ theme }: { theme: Theme }) => resolveSecurityQuestionContainerPadding(theme),
    },
    securityQuestionError: {
        "& $questionValidation + div $secQuestionTitle": {
            paddingTop: ({ theme }: { theme: Theme }) =>
                useModernSecurityQuestionStyles(theme) ? 0 : undefined,
        },
        "& $questionValidation + div $secQuestionText": {
            paddingTop: ({ theme }: { theme: Theme }) =>
                useModernSecurityQuestionStyles(theme) ? 0 : undefined,
        },
        "& $questionValidation": {
            marginBottom: ({ theme }: { theme: Theme }) =>
                resolveQuestionErrorToLabelGap(theme) ?? undefined,
        },
    },
    questionValidation: {
        alignItems: "center",
        composes: "question__validation",
        display: "inline-flex",
    },
    questionContainer: {
        marginBottom: ({ theme }: { theme: Theme }) =>
            resolveSecurityQuestionFieldMarginBottom(theme),
    },
    answerContainer: {
        marginBottom: ({ theme }: { theme: Theme }) =>
            resolveSecurityQuestionAnswerMarginBottom(theme),
    },
    questionValidationFocus: {
        borderLeftColor: ({ theme }: { theme: Theme }) => theme.ErrorColor,
        composes: "question__validation-focus",
    },
    dynamicQuestionValidationFocus: {
        borderLeftStyle: "solid",
        borderLeftWidth: 3,
        left: -30,
        paddingLeft: 30,
        position: "relative",
        width: "100%",
    },
} as any);
